import { render, staticRenderFns } from "./CalendarListItem.vue?vue&type=template&id=06a1bee9&scoped=true&"
import script from "./CalendarListItem.vue?vue&type=script&lang=js&"
export * from "./CalendarListItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarListItem.vue?vue&type=style&index=0&id=06a1bee9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1bee9",
  null
  
)

export default component.exports